import React    from 'react';
let FaCross     = require('react-icons/lib/fa/close');
let Claim       = require('../Managers/Claim');

const DeleteClaimsModal = React.createClass({
    propTypes: {
        deleteClaim : React.PropTypes.func,
        resetClaimsQuestion : React.PropTypes.func,
    },
    getDefaultProps() {
        return {
            earliest : 2014,
            latest : 2016,
        };
    },

    getInitialState() {
        return {
            showModal: false,
            guid : '',
            type : 0,
            value : '',
            month : '',
            year : '',
        };
    },

    showClaimsModal : function(claim) {
        if (undefined != claim) {
            this.setState({
                guid : claim.guid,
                type : claim.type,
                value : claim.value,
                month : claim.month,
                year : claim.year,
            });
        } else {
            this.flushState();
        }
        this.setState({
            showModal : true
        });
    },

    hideClaimsModal : function() {
        this.setState({
            showModal : false
        });
    },

    flushState : function() {
        this.setState({
            guid : '',
            type : '',
            value : '',
            month : '',
            year : '',
        });
    },

    deleteClaim : function() {
        if (this.state.type == 0) {
            return false;
        }

        // add the claim via the parent
        this.props.deleteClaim(this.state.guid);

        // flush state here
        this.flushState();

        // then hide it
        this.hideClaimsModal();

        // then if we have no claims, call the parent to set it back to no
        let claims = Claim.get();
        if (window.isEmpty(claims)) {
            this.props.resetClaimsQuestion();
        }
    },

    render() {
        return (
            <modal-container class={this.state.showModal ? 'modal-active' : null}>
                <modal className="has-footer small-width">
                    <div className="modal-header">
                        Delete a Claim
                        <a className="close-cross" onClick={this.hideClaimsModal}>
                            <FaCross />
                        </a>
                    </div>
                    <div className="modal-body">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Type</td>
                                        <td>{Claim.getTypeStringForId(this.state.type)}</td>
                                    </tr>
                                    <tr>
                                        <td>Value</td>
                                        <td>&pound;{this.state.value}</td>
                                    </tr>
                                    <tr>
                                        <td>Date</td>
                                        <td>{this.state.month}/{this.state.year}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a onClick={this.hideClaimsModal}
                           className="btn btn-default pull-right">Cancel/Close</a>
                        <a onClick={this.deleteClaim}
                           className="btn btn-warning">Delete Claim</a>
                    </div>
                </modal>
            </modal-container>
        );
    }
});

export default DeleteClaimsModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/DeleteClaimsModal.js
 **/